const NoSearchResultContainer = ({ data }) => {
  return (
    <section
      className="bg-light-blue-grey lg:-mt-10 lg:pt-20 lg:pb-20 md:pb-5 md:pt-7"
      id="no-results-container"
    >
      <article className="container">
        <h2
          className="text-lg"
          dangerouslySetInnerHTML={{ __html: data.heading }}
        />
      </article>
    </section>
  );
};

export default NoSearchResultContainer;
